import React from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import AnalyticsSearchLog from "src/routes/app/analytics/AnalyticsSearchLog";
import AnalyticsSearchLogView from "src/routes/app/analytics/search-log/AnalyticsSearchLogView";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
export default function AnalyticsIndex(props) {
  var id = useURLParam('id');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Analytics",
    icon: "bar-chart-2"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "search",
    menuItems: [{
      id: "search",
      icon: "search",
      label: "Search",
      content: /*#__PURE__*/React.createElement(AnalyticsSearchLog, null),
      queryString: {
        id: undefined
      }
    }, {
      id: "view",
      icon: "eye",
      label: "View",
      content: /*#__PURE__*/React.createElement(AnalyticsSearchLogView, null),
      show: id !== null
    }]
  }));
}

// @ts-ignore